import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";

// dashboard routing
//admin route
const GeneralSettings = Loadable(lazy(() => import("views/settings/General")));
const UpdateProfile = Loadable(
  lazy(() =>
    import("./../layout/MainLayout/Header/ProfileSection/UpdateProfile")
  )
);
const ChangePassword = Loadable(
  lazy(() =>
    import("./../layout/MainLayout/Header/ProfileSection/ChangePassword")
  )
);

//user route
const Dashboard = Loadable(lazy(() => import("views/Dashboard/Index")));
const Analytics = Loadable(lazy(() => import("views/Analytics/Analytics")));
const UsersPage = Loadable(lazy(() => import("views/users/index")));
const EditUser = Loadable(lazy(() => import("views/users/EditUsers")));
const AddUserForm = Loadable(lazy(() => import("views/users/AddUserForm")));
const UserDetail = Loadable(lazy(() => import("views/users/UserDetailsTab")));
//department route
const ContentManagement = Loadable(lazy(() => import("views/cms/index")));
const EditContentManagement = Loadable(
  lazy(() => import("views/cms/EditContentManagement"))
);
const AddContentManagement = Loadable(
  lazy(() => import("views/cms/AddContentManagement"))
);
const CmsDetail = Loadable(lazy(() => import("views/cms/CmsDetail")));
const Language = Loadable(lazy(() => import("views/Language/Index")));
const EditLanguage = Loadable(
  lazy(() => import("views/Language/EditLanguage"))
);
const Labels = Loadable(lazy(() => import("views/Labels/Index")));
const ReportedProperties = Loadable(
  lazy(() => import("views/staff/ReportedProperties/Index"))
);
const Notification = Loadable(
  lazy(() => import("views/staff/Notification/Index"))
);
const PropertyOwner = Loadable(
  lazy(() => import("views/staff/PropertyOwner/Index"))
);
const PropertyOwnerDetail = Loadable(
  lazy(() => import("views/staff/PropertyOwner/PropertyDetailsTab"))
);
const EditPropertyOwner = Loadable(
  lazy(() => import("views/staff/PropertyOwner/EditPropertyOwner"))
);
const TenantList = Loadable(lazy(() => import("views/TenantList/TenantList")));
const ViewTenantList = Loadable(
  lazy(() => import("views/TenantList/ViewTenantList"))
);
const PropertyRequest = Loadable(
  lazy(() => import("views/PropertyRequest/Index"))
);
const PropertyRequestDetail = Loadable(
  lazy(() => import("views/PropertyRequest/PropertyRequestDetail"))
);
const ChatMainPage = Loadable(lazy(() => import("views/Chat/index.js")));
const EmailTemplate = Loadable(lazy(() => import("views/EmailTemplate/Index")));
const EditEmailTemplate = Loadable(
  lazy(() => import("views/EmailTemplate/EditEmailTemplate"))
);
const StaffSupport = Loadable(lazy(() => import("views/StaffSupport/Index")));
const ViewStaffSupport = Loadable(
  lazy(() => import("views/StaffSupport/ViewStaffSupport/index"))
);
const Properties = Loadable(lazy(() => import("views/Properties/Index")));
const AddPropertyForm = Loadable(
  lazy(() => import("views/Properties/AddPropertyForm"))
);
const EditPropertyForm = Loadable(
  lazy(() => import("views/Properties/EditPropertyForm"))
);
const ViewProperty = Loadable(
  lazy(() => import("views/Properties/PropertyTabPanel"))
);
const EditProperty = Loadable(
  lazy(() => import("views/Dashboard/EditProperties"))
);
const DashboardAnalytics = Loadable(
  lazy(() => import("./../views/Dashboard/Analytics"))
);
const AgencyRent = Loadable(lazy(() => import("views/AgencyRent/Index")));
const ViewAgencyRent = Loadable(
  lazy(() => import("views/AgencyRent/ViewAgencyRent"))
);
const QuestionAnswer = Loadable(
  lazy(() => import("views/QuestionAnswer/Index"))
);
const AddQuestion = Loadable(
  lazy(() => import("views/QuestionAnswer/AddQuestion"))
);

const AddPropertyStepperForm = Loadable(
  lazy(() =>
    import("views/Properties/AddPropertyStepperForm/AddPropertyStepperForm")
  )
);
const Testimonials = Loadable(lazy(() => import("views/Testimonials/Index")));
const AddTestimonial = Loadable(
  lazy(() => import("views/Testimonials/AddTestimonial"))
);
const ViewTestimonialDetails = Loadable(
  lazy(() => import("views/Testimonials/ViewTestimonialDetails.js"))
);
const Partners = Loadable(lazy(() => import("views/Partners/Index")));
const PropertyField = Loadable(lazy(() => import("views/PropertyField/index")));
const AddPropertyField = Loadable(
  lazy(() => import("views/PropertyField/AddPropertyField"))
);
const EditPropertyField = Loadable(
  lazy(() => import("views/PropertyField/EditPropertyField"))
);
const ContactUs = Loadable(lazy(() => import("views/ContactUs/Index")));
const Setting = Loadable(lazy(() => import("views/Setting/Setting")));
const Ads = Loadable(lazy(() => import("views/Ads/Ads")));
const UnverifiedPropertyDetail = Loadable(
  lazy(() => import("views/Dashboard/UnverifiedPropertyDetails"))
);
const RentalContracts= Loadable(lazy(() => import("views/RentalContract/RentalContract")));
// ==============================|| MAIN ROUTING ||============================== //

const StaffRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/dashboard/analytics/:id",
      element: <DashboardAnalytics />,
    },
 
    {
      path: "/analytics",
      element: <Analytics />,
    },
    {
      path: "/users",
      element: <UsersPage />,
    },
    {
      path: "/users/add",
      element: <AddUserForm />,
    },
    {
      path: "/users/edit/:id",
      element: <EditUser />,
    },
    {
      path: "/users/view/:id",
      element: <UserDetail />,
    },
    {
      path: "/unveified-property-detail/view/:id/:pid",
      element:<UnverifiedPropertyDetail/>
    },
    {
      path: "/chat",
      element: <ChatMainPage />,
    },
    {
      path: "/chat/:id",
      element: <ChatMainPage />,
    },
    {
      path: "/email-template",
      element: <EmailTemplate />,
    },
    {
      path: "/email-template/edit/:id",
      element: <EditEmailTemplate />,
    },
    {
      path: "/staff-support",
      element: <StaffSupport />,
    },
    {
      path: "/staff-support/view/:id",
      element: <ViewStaffSupport />,
    },
    {
      path: "/tenant-list",
      element: <TenantList />,
    },
    {
      path: "/tenant-list/view/:id",
      element: <ViewTenantList />,
    },
    {
      path: "/property-owner",
      element: <PropertyOwner />,
    },
    {
      path: "/property-request",
      element: <PropertyRequest />,
    },
    {
      path: "/property-request-detail/view/:id/:pid",
      element: <PropertyRequestDetail />,
    },
    {
      path: "/property-owner/edit/:id",
      element: <EditPropertyOwner />,
    },
    {
      path: "/property-owner/view/:id",
      element: <PropertyOwnerDetail />,
    },

    {
      path: "/reported-properties",
      element: <ReportedProperties />,
    },
    {
      path: "/properties",
      element: <Properties />,
    },
    {
      path: "/property/add",
      element: <AddPropertyForm />,
    },
    {
      path: "/property/register",
      element: <AddPropertyStepperForm />,
    },
    {
      path: "/property/update/:id",
      element: <AddPropertyStepperForm />,
    },
    { path: "/property/edit/:id", element: <EditProperty /> },
    { path: "/properties/edit/:id", element: <EditPropertyForm /> },
    {
      path: "/properties/view/:id/:oid",
      element: <ViewProperty />,
    },
    {
      path: "/notification",
      element: <Notification />,
    },
    {
      path: "/content-management",
      element: <ContentManagement />,
    },
    {
      path: "/content-management/edit/:id",
      element: <AddContentManagement />,
    },
    {
      path: "/content-management/add",
      element: <AddContentManagement />,
    },
    {
      path: "/setting",
      element: <Setting />,
    },
    {
      path: "/settings/general",
      element: <GeneralSettings />,
    },
    {
      path: "/update-profile",
      element: <UpdateProfile />,
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    {
      path: "/agency-rent",
      element: <AgencyRent />,
    },
    {
      path: "/agency-rent/view/:id",
      element: <ViewAgencyRent />,
    },
    {
      path: "/question-answer",
      element: <QuestionAnswer />,
    },
    {
      path: "/question-answer/add",
      element: <AddQuestion />,
    },
    {
      path: "/question-answer/edit/:id",
      element: <AddQuestion />,
    },
    {
      path: "/partners",
      element: <Partners />,
    },
    {
      path: "/testimonials",
      element: <Testimonials />,
    },
    {
      path: "/testimonials/add",
      element: <AddTestimonial />,
    },
    {
      path: "/testimonials/edit/:id",
      element: <AddTestimonial />,
    },
    {
      path: "/testimonials/view/:id",
      element: <ViewTestimonialDetails />,
    },
    {
      path: "/property-field",
      element: <PropertyField />,
    },
    {
      path: "/property-field/add",
      element: <AddPropertyField />,
    },
    {
      path: "/property-field/edit/:id",
      element: <EditPropertyField />,
    },
    {
      path: "/contact-us",
      element: <ContactUs />,
    },
    {
      path: "/ads",
      element: <Ads />,
    },
    {
      path: "/languages",
      element: <Language />,
    },
 
    { path: "/labels", element: <Labels /> },
    {
      path:"/rental-contract",
      element:<RentalContracts/>
    }
  ],
};

export default StaffRoutes;
